import React, { ReactElement } from 'react';

const Camera = (): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
      <g clip-path="url(#clip0_6255_5318)">
        <path
          d="M6 8.06667C7.06039 8.06667 7.92 7.19113 7.92 6.11111C7.92 5.03109 7.06039 4.15556 6 4.15556C4.93961 4.15556 4.08 5.03109 4.08 6.11111C4.08 7.19113 4.93961 8.06667 6 8.06667Z"
          fill="#AFB0B1"
        />
        <path
          d="M4.2 0L3.102 1.22222H1.2C0.54 1.22222 0 1.77222 0 2.44444V9.77778C0 10.45 0.54 11 1.2 11H10.8C11.46 11 12 10.45 12 9.77778V2.44444C12 1.77222 11.46 1.22222 10.8 1.22222H8.898L7.8 0H4.2ZM6 9.16667C4.344 9.16667 3 7.79778 3 6.11111C3 4.42444 4.344 3.05556 6 3.05556C7.656 3.05556 9 4.42444 9 6.11111C9 7.79778 7.656 9.16667 6 9.16667Z"
          fill="#AFB0B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_6255_5318">
          <rect width="12" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Camera;
